import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Question, ClassMapper } from 'mapfre-auditlib';
import * as _ from 'lodash';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class QuestionService {

  className = 'QuestionService';

  constructor(private http: HttpClient) {
  }

  getAllQuestions(): Observable<Question[]> {
    return this.http.get<Question[]>(environment.base_URL + "/questions").pipe(map(res => {
      return ClassMapper.fromJSONArray(res, Question);
    }))
  }

  newQuestion(newQuestion: any) {
    return this.http.post(environment.base_URL + "/questions", newQuestion);
  }

  updateQuestion(editedQuestion, id) {
    return this.http.put(environment.base_URL + `/questions/${id}`, editedQuestion)
  }

  getIsRead() {
    return of([
      { name: 'FILTERS.YES', value: true },
      { name: 'FILTERS.NO', value: false }
    ]);
  }

  getIsComplete() {
    return of([
      { name: 'FILTERS.YES', value: true },
      { name: 'FILTERS.NO', value: false }
    ]);
  }

  getAllAudited() {
    return this.http.get(environment.base_URL + "/questionnaires/audited").pipe(map(res => {
      return _.map(res, (q: any) => {
        let totalValoration = 0;
        let totalNumerableQuestions = 0;
        _.forEach(q.evaluations, (e) => {
          let question = _.get(e, 'questionnaireQuestion.question');
          let isNumerable = _.get(question, 'optionQuestion');
          let valoration = _.get(e, 'mumEvaluationValue', 0);
          if (isNumerable) {
            totalNumerableQuestions++;
            totalValoration += valoration;
          }
        })
        q.evaluations = _.sortBy(q.evaluations, (e) => {
          return _.get(e, 'questionnaireQuestion.nmrOrder');
        });
        q.valoration = totalNumerableQuestions ? (totalValoration / totalNumerableQuestions).toFixed(2) : 0;
        return q;
      })
    }));
  }

  read(evaluationsIds) {
    return this.http.put(environment.base_URL + "/questionnaires/reading", evaluationsIds)
  }

  send(questionnaire) {
    return this.http.post(environment.base_URL + "/questionnaires/audited", questionnaire)
  }

}
